import * as SelectPrimitive from '@radix-ui/react-select';

export const PvSelect = SelectPrimitive.Root;
